<script setup>
defineOptions({
  inheritAttrs: false,
})

const hasContent = defineModel()
hasContent.value = true

async function waitUntil(fn) {
  while (!fn())
    await new Promise(resolve => setTimeout(resolve, 250))
}

const el = ref(null)
const isLoading = ref(null)

onMounted(async () => {
  await waitUntil(() => !isLoading.value)
  const rawInnerHtml = el.value?.innerHTML
  const commentRegex = /<!--.*-->/g
  const trimmedHtml = rawInnerHtml?.replaceAll(commentRegex, '').trim()
  hasContent.value = !!trimmedHtml?.length
})
</script>

<template>
  <div ref="el">
    <Suspense>
      <slot />
      <template #fallback>
        <div ref="isLoading">
          ...
        </div>
      </template>
    </Suspense>
  </div>
</template>
